var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Button from "@/components/Button";
import { useAuth } from "@/hooks/useAuth";
import toast from "react-hot-toast";
import { useState } from "react";
export default function Login() {
    var _this = this;
    var loginWithCognito = useAuth().loginWithCognito;
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var handleCognitoLogin = function () { return __awaiter(_this, void 0, void 0, function () {
        var toastID, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    toastID = toast.loading("Redirecting to Cognito...");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loginWithCognito()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    toast.error(err_1.message, { id: toastID });
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "flex flex-col gap-6 px-4 sm:gap-8 sm:px-8 lg:px-14", children: [_jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("h1", { className: "text-xl", children: "Welcome back!" }), _jsx("p", { className: "text-xs font-medium text-[#858585]", children: "Sign in to your account" })] }), _jsx(Button, { type: "button", onClick: handleCognitoLogin, disabled: isLoading, children: "Sign in" })] }), _jsxs("p", { className: "my-6 px-4 text-center text-xs font-medium text-[#858585] sm:my-8 sm:px-8", children: ["Don't have an account?", " ", _jsx("a", { href: "/register", className: "text-[#1BC5BD]", children: "Sign up" })] }), _jsxs("p", { className: "px-4 text-center text-xs font-medium text-[#B5B5C3] sm:px-8", children: ["By logging in, you agree to our", " ", _jsx("a", { href: "/tnc", className: "text-[#1BC5BD]", target: "_blank", rel: "noopener noreferrer", children: "Terms and Conditions" }), " ", "&", " ", _jsx("a", { href: "/privacy-policy", className: "text-[#1BC5BD]", target: "_blank", rel: "noopener noreferrer", children: "Privacy Policy" })] })] }));
}
